import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useStore from "../../store";
import withAuth from "../Auth/withAuth";

function LOM() {
  const navigate = useNavigate();

  const { logout, setPageTitle, isLoggedIn, data, tenantId } = useStore(
    (state) => state
  );

  useEffect(() => {
    setPageTitle("My Private Lessons");
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      logout();
      navigate(`/?tenantId=${tenantId}`);
    }
  }, []);

  return (
    <div>
      <iframe title="my-iframe" width="100%" height="1000px" src={`#`}></iframe>
    </div>
  );
}

export default withAuth(LOM);
